/**
 * Data people measurement mock
 */

// Models
import { IParamGetList } from 'models/UserRequest';

// Utils
import { RowHeader } from 'utils/types';
import { ParamsGetListSetting } from 'utils/constants';

export const headerPeopleMeasurement: RowHeader[] = [
  { id: 'id', label: 'No', position: 'center', haveSort: false },
  { id: 'status', label: '利用状況', position: 'center', haveSort: false },
  { id: 'user_company', label: '企業名/団体名' },
  { id: 'user_department', label: '所属' },
  { id: 'user_name', label: '名前' },
  { id: 'user_email', label: 'メールアドレス' },
  { id: 'event_name', label: 'イベント名' },
  { id: 'event_start_date', label: '開催日' },
  { id: 'event_end_date', label: '終了日' },
  { id: 'camera_count', label: 'カメラ台数' },
  { id: 'has_layout', label: '処理アップロード' },
  { id: 'has_map', label: '図面アップロード' },
];

export const defaultParamsPeopleMeasurement: IParamGetList = {
  keyword: '',
  order_by: 'desc',
  sort_name: 'event_start_date',
  page: ParamsGetListSetting.DEFAULT_PAGE as number,
  per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
};
